import { useLocation } from 'react-router';
import { useMemo } from 'react';

import { useStoredDocumentUrl } from './Documents/useDocumentUrl';

// Check whether the current location equals the url of the current document
export const useIsDocumentLocationUrlValid = (slug: string) => {
  const location = useLocation();
  const documentUrl = useStoredDocumentUrl(slug);

  return useMemo(() => {
    if (documentUrl) {
      const locationStripped = location.pathname.replace(/\/$/, '');
      return documentUrl.trim() === locationStripped.trim();
    }
    return false;
  }, [documentUrl, location]);
};
